import React from 'react';
import dayjs from "dayjs";
import classnames from 'classnames';
import FieldTextareaAutosize from "../../../../common/components/FieldTextareaAutosize";
import FieldDatepicker from "../../../../common/components/FieldDatepicker";
import FieldSelect from "../../../../common/components/FieldSelect";
import {taskStatuses} from '../../../../common/constants/options';
import styles from './styles.module.scss';

const TaskGeneral = ({formik}) => {

  return (
    <div className={styles.modalContentContainer}>
      <FieldTextareaAutosize
        fieldId="taskDescription"
        value={formik.values.taskDescription}
        mandatoryMark={true}
        label={'פירוט משימה'}
        containerCustomStyles={styles.paddingBottom}
      />
      <div className={classnames(styles.fullRow, styles.paddingBottom)}>
        <FieldDatepicker
          fieldId="taskDueDate"
          label={'תאריך לביצוע'}
          mandatoryMark={true}
          maxDate={dayjs().add(10, 'year')}
          containerStyles={styles.halfSize}
        />
        <FieldSelect
          fieldId="taskStatusID"
          options={taskStatuses}
          mandatoryMark={true}
          label={'סטטוס'}
          containerStyles={styles.halfSize}
        />
      </div>
    </div>
  )
};

export default TaskGeneral;
